<template>
  <div class="recharge">
    <Header title="充币" :show-back="true">
      <span slot="right" @click="$router.push('/accoundRecord')">充值记录</span>
    </Header>
    <div class="container">
      <van-cell
      
        class="select-item"
        title="选择币种类型"
        title-class="select-item-title"
        value-class="select-item-value"
        :value="coin"
       
      />
      <div class="recharge-code">
        <!--二维码-->
        <div class="ercodeImg" ref="qrcode" id="ercodeImg"></div>
        <button class="form-item-btn">截取二维码保存到相册</button>
      </div>
      <div class="recharge-address">
        <p>充值地址：</p>
        <p class="value" id="address">
          {{address}}
        </p>
      </div>
      <button class="form-item-btn copy"  @click="copyEvent" id="copy" data-clipboard-target="#address" >复制地址</button>
    </div>
    <div class="rules">
      <div class="rules-title">
        <img src="../../assets/img/share/warn.png" />
        <span>温馨提示：</span>
      </div>
      <dl class="text">1、<p>最小充值金额: 1 USDT,小于最小金额的充值将不会上账且无法退回。</p></dl>
      <dl class="text">2、<p>您的充值地址不会经常改变，可以重复充值;如有更改，我们会尽量通过

网站公告或邮件通知您。</p></dl>
      <dl class="text">3、<p>请务必确认电脑及浏览器安全，防止信息被篡改或泄露。</p></dl>
    </div>
     <!-- <van-action-sheet
      v-model="showSelect"
      :actions="columns"
      cancel-text="取消"
      @select="onSelect"
      @cancel="onCancelSelect"
      :round="false"
    /> -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
  import Clipboard from "clipboard";
import Header from "../../components/header";
export default {
  components: {
    Header
  },
  data() {
    return {
     showSelect:false,
     coin:'USDT',
     address:'',
     columns:[
      {
          name:"QC",
          text:'QC-QTUM'
      },
        {
          name:"DNAT",
          text:'DNAT-ERC20'
      },
        {
          name:"USDT",
          text:'USDT-OMINI'
      },
     ]
    };
  },
  mounted() {
    this.getAddress()
   
  },
  methods: {
    qrcode() {
      this.$refs.qrcode.innerHTML = "";
       let qrcode = new QRCode("ercodeImg", {
        errorCorrectionLevel: "H",
        width: 165,
        height: 165,
        text: this.address // 二维码内容
      });
      console.log(qrcode)
    },

    onSelect(item){
      this.coin = item.name
      this.getAddress()
      this.showSelect = false
    },
    onCancelSelect(){
      this.showSelect = false
    },
    showSelectClick(){
      this.showSelect = true
    },
     /*复制功能*/
    copyEvent() {
        let clipboard = new Clipboard("#copy");
        clipboard.on("success", (e) => {
            this.$toast('复制成功');
            e.clearSelection();
        });
        clipboard.on("error", (e) => {
            // 不支持复制
            this.$toast("暂不支持复制功能");
            e.clearSelection();
        });
    },
    getAddress(){
      this.ajax.post('appapi/Coin/getAddress',{coin:this.coin.toLowerCase()}).then((res)=>{
        if(res.data.code ===1){
          this.address = res.data.data.address
          this.$nextTick(() => {
              this.qrcode();
          })
        }
      })
    }
  }
};
</script>

<style lang="scss">
.recharge {
  .container {
    margin: 30px;

    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 29px 0px rgba(226, 226, 226, 0.5);
    border-radius: 20px;
    .select-item {
      background: #fff;
      box-shadow: 0px 5px 12px 0px rgba(226, 226, 226, 0.2);
      border-radius: 20px 20px 0px 0px;
      &-title {
        color: #6f788b;
        font-size: 26px;
      }
      &-value {
        font-size: 28px;
        color: #333;
        font-weight: bold;
      }
    }
  }
  &-code {
    padding: 65px 167px 44px;
    .ercodeImg {
      width: 356px;
      height: 356px;
      box-sizing: border-box;
      padding: 13px;
      margin-bottom: 51px;
    }
  }
  &-address {
    padding: 40px 40px 49px 37px;
    border-top: 1px solid #f2f5f9;
    color: #6f788b;
    font-size: 26px;
    .value {
      color: #424d63;
      font-size: 28px;
      font-weight: bold;
      margin-top: 25px;
    }
  }
  .copy {
    width: 212px;
    margin: 0 239px 45px;
  }
  .rules {
    margin: 30px 30px;
    padding: 0 30px 45px;
    background: #f9f9f9;
    color: #777777;
    font-size: 24px;
    border-radius: 10px;
    &-title {
      font-size: 26px;
      padding: 30px 0;
      img {
        width: 28px;
        height: 24px;
        margin-right: 11px;
      }
    }
     .text{
      display:flex;
    }
    p {
      line-height: 28px;
      margin-bottom: 30px;
    }
  }
}
</style>